import { render } from "./PreventiveSleepApnea.vue?vue&type=template&id=557134ee"
import script from "./PreventiveSleepApnea.vue?vue&type=script&lang=js"
export * from "./PreventiveSleepApnea.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__